module.exports = __webpack_public_path__ + "img/IMG_5529.bd04ed24.jpg";